import { render, staticRenderFns } from "./UserDialogue.vue?vue&type=template&id=46259a2e"
import script from "./UserDialogue.vue?vue&type=script&lang=ts"
export * from "./UserDialogue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports